import { render, staticRenderFns } from "./ExamMostIncorrectQuestion.vue?vue&type=template&id=1bd1f87a&scoped=true"
import script from "./ExamMostIncorrectQuestion.vue?vue&type=script&lang=js"
export * from "./ExamMostIncorrectQuestion.vue?vue&type=script&lang=js"
import style0 from "./ExamMostIncorrectQuestion.vue?vue&type=style&index=0&id=1bd1f87a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd1f87a",
  null
  
)

export default component.exports